export default "__VITE_ASSET__Dh$6oOUz__"